module.exports = __webpack_public_path__ + "static/img/copyright4.a8f4e4b6.png";